import { SimpleSearchForm, SimpleSearchGrid } from "@/features/search";
import { filterValidValuesToObject } from "@/shared/lib";
import { vars } from "@/shared/lib/theme.css";
import { SimpleSearchFormType } from "@/shared/model";
import { Center, Column, Indicator } from "@/shared/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/(auth)/_layout/search/simple-search")({
	component: SimpleSearchScreen,
	validateSearch: (search: Partial<SimpleSearchFormType>): Partial<SimpleSearchFormType> => {
		return filterValidValuesToObject<SimpleSearchFormType, SimpleSearchFormType>(search);
	}
});

function SimpleSearchScreen() {
	return (
		<Column
			fullWidth
			style={{
				justifyContent: "flex-start",
				alignItems: "flex-start",
				gap: vars.size[32],
				paddingBottom: 200,
			}}
		>
			<Column
				fullWidth
				style={{
					position: "sticky",
					top: 0,
					zIndex: 100,
					backgroundColor: vars.color.white,
					paddingBottom: vars.size[16]
				}}
			>
				<SimpleSearchForm />
			</Column>
			<Suspense
				fallback={
					<Center fullWidth style={{ minHeight: "100vh" }}>
						<Indicator />
					</Center>
				}
			>
				<SimpleSearchGrid />
			</Suspense>
		</Column>
	);
}
